export default class TopNavigation {
    constructor(elm) {
        this.elm = elm;
        const self = this;
        this.isOpen = false;
        const navItems = elm.querySelectorAll('.top-navigation__menu-item');
        const mobileToggle = elm.querySelectorAll('[data-top-navigation__toggle]');
        const curtainElem = elm.querySelector('.top-navigation__curtain');
        const subMenus = [];
        const heroStyle = elm.classList.contains('top-navigation--hero-style');
        window.timeouts = [];
        let currentOpenSubMenu = null; // will hold reference to the currently opened submenu
        let heroTypeInitialized = false;
        const desktopBreakpoint = 992;
        window.throttledScrollHandler = null;
        let scrollHandlerAssigned = false;
        let curtainAnimated = false;
        let lastScroll = 0;

        import('lodash/throttle')
            .then(result => {
                return result.default;
            })
            .then(throttle => {
                lastScroll = 0;
                const threshold = 5;

                const handleScroll = throttle(function () {
                    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

                    if (Math.abs(currentScroll - lastScroll) > threshold) {
                        const scrollFromBottom = document.body.offsetHeight - (currentScroll + window.innerHeight);
                        if (currentScroll > lastScroll && currentScroll > 50 && scrollFromBottom > 90) {
                            document.body.classList.add('scrolling-down');
                            document.body.classList.remove('scrolling-up');
                            if (window.innerWidth > desktopBreakpoint) {
                                document.body.classList.remove('search-bar-open');
                            }
                        } else {
                            document.body.classList.remove('scrolling-down');
                            document.body.classList.add('scrolling-up');
                        }
                        lastScroll = currentScroll;
                    }
                }, 200);

                window.addEventListener('scroll', handleScroll);
            });

        navItems.forEach((navItem) => {
            const subMenu = navItem.querySelector('.top-navigation__menu-item__submenu');

            if (subMenu) {
                subMenus.push(new SubMenu(navItem));

                navItem.addEventListener('onOpened', function (e) {
                    currentOpenSubMenu = e.detail;
                });
                navItem.addEventListener('onClosed', function (e) {
                    currentOpenSubMenu = null;
                });
            }

        }, this);

        this._open = function () {
            this.elm.classList.add('top-navigation--menu-open');
            document.body.classList.add('menu-open');
            this.isOpen = true;
        };

        this._close = function () {
            // if no open submenu, just close
            if (!currentOpenSubMenu) {
                this.elm.classList.remove('top-navigation--menu-open');
                document.body.classList.remove('menu-open');
                this.isOpen = false;
            } else {
                let onClosedEventHandler = null;
                onClosedEventHandler = function (e) {
                    self._close();
                    e.detail.elm.removeEventListener('onClosed', onClosedEventHandler);
                };

                // Assign eventlistener to submenu, to close self when submenu is closed
                currentOpenSubMenu.elm.addEventListener('onClosed', onClosedEventHandler);
                // Close currently open submenu
                currentOpenSubMenu.close();
            }
        };

        mobileToggle.forEach(toggle => {
            toggle.addEventListener('click', this.toggle.bind(this));
        });

        this._initializeHeroType = function () {
            if (heroTypeInitialized) {
                return;
            }
            heroTypeInitialized = true;
            const navBarHeight = 85;

            self._animateToHeroStyle = function () {
                if (self.elm.classList.contains('top-navigation--hero-style')) { return; }
            };

            self._animateOffHeroStyle = function () {
                if (!self.elm.classList.contains('top-navigation--hero-style')) { return; }
            };

            // Method for toggling the hero specific styles on and off
            const determineHeroStyle = function () {
                if (window.scrollY > navBarHeight) {
                    self._animateOffHeroStyle();
                } else if (window.scrollY <= navBarHeight) {
                    self._animateToHeroStyle();
                }
            };

            // if viewport is above desktop, determine hero style.
            if (window.innerWidth > desktopBreakpoint) {
                determineHeroStyle();
            }
            const textContainer = document.querySelector('.hero__text-container');

            let scrollPos = 0;
            let targetScrollPos = 0;
            const speed = 0.15;

            function smoothScroll() {
                if (window.listenToScroll) {
                    const diff = targetScrollPos - scrollPos;
                    if (Math.abs(diff) > 0.001) {
                        scrollPos += diff * speed;
                    } else {
                        scrollPos = targetScrollPos;
                    }

                    document.documentElement.style.setProperty('--scroll', scrollPos);
                    if (scrollPos < 0.5) {
                        elm.classList.add('animating-hero');
                    } else {
                        elm.classList.remove('animating-hero');
                    }
                } else {
                    document.documentElement.style.setProperty('--scroll', 0);
                }
                window.requestAnimationFrame(smoothScroll); // Continue the loop
            }

            window.requestAnimationFrame(smoothScroll);

            // Import throttle from lodash and assign scroll handler to apply
            import('lodash/throttle')
                .then(result => {
                    return result.default;
                })
                .then(throttle => {
                    window.throttledScrollHandler = throttle(determineHeroStyle, 100, { leading: false });
                    // Method for conditionally assigning scroll event listener - based on viewport width and current assigned status
                    const conditionallyAssignScrollEventListener = function () {
                        if (window.innerWidth >= desktopBreakpoint && !scrollHandlerAssigned) {
                            scrollHandlerAssigned = true;
                            window.addEventListener('scroll', window.throttledScrollHandler);
                            window.addEventListener('scroll', () => {
                                targetScrollPos = window.pageYOffset / (textContainer.offsetTop + 25);
                            });
                        } else if (window.innerWidth < desktopBreakpoint && scrollHandlerAssigned) {
                            scrollHandlerAssigned = false;
                            window.removeEventListener('scroll', window.throttledScrollHandler);
                        }
                    };
                    conditionallyAssignScrollEventListener();

                    // When window resizes, recheck if scroll event listener should be assigned.
                    window.addEventListener('resize', throttle(conditionallyAssignScrollEventListener, 100, { leading: false }));
                });
        };

        this._animateInCurtain = function () {
            if (curtainAnimated) {
                return;
            }
        };

        this._removeCurtain = function () {
            if (!curtainAnimated) {
                return;
            }

            curtainElem.style.height = null;
            curtainAnimated = false;
        };

        this._disableHeroType = function () {
            if (!heroTypeInitialized) {
                return;
            }
            heroTypeInitialized = false;
            scrollHandlerAssigned = false;
            window.removeEventListener('scroll', window.throttledScrollHandler);
            window.throttledScrollHandler.cancel();
        };

        // Apply additionaly logic for pages that apply "hero styling" to the navigation bar
        if (heroStyle) {
            this._initializeHeroType();
        }
    }

    animateOffHeroStyle() {
        if (this._animateOffHeroStyle) {
            return this._animateOffHeroStyle();
        }
    }

    animateToHeroStyle() {
        if (this._animateToHeroStyle) {
            return this._animateToHeroStyle();
        }
    }

    animateInCurtain() {
        return this._animateInCurtain();
    }

    removeCurtain() {
        return this._removeCurtain();
    }

    open() {
        this._open();
    }

    close() {
        this._close();
    }

    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    toggleHeroNavigationType(isHeroType) {
        if (isHeroType) {
            this._initializeHeroType();
        } else {
            this._disableHeroType();
        }
    }
}

class SubMenu {
    constructor(elm) {
        this.elm = elm;
        const self = this;
        this.isOpen = false;
        const toggleOpenElem = elm.querySelector('[data-top-navigation__submenu-open]');
        const toggleCloseElem = elm.querySelector('[data-top-navigation__submenu-close]');
        const subMenuSections = [];
        const submenu = elm.querySelector('.top-navigation__menu-item__submenu');
        let currentOpenSubMenu = null; // will hold reference to the currently opened submenu
        let subMenuSectionsInitialized = false;
        const onClosedEvent = new CustomEvent('onClosed', { detail: this });
        const onOpenedEvent = new CustomEvent('onOpened', { detail: this });
        elm.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
            submenu.classList.add('no-hover');
            setTimeout(() => {
                submenu.classList.remove('no-hover');
            }, 1000);
        }));

        // detect clicks outside the submenu - if clicked outside, close the submenu
        const handleClickOutside = function (e) {
            e.preventDefault();

            const clickedMainNavItem = e.target.closest('.top-navigation__menu-item');
            if (!clickedMainNavItem || clickedMainNavItem !== elm) {
                self._close();
            }
        };

        const initializeSubMenuSections = function () {
            elm.querySelectorAll('.top-navigation__menu-item__submenu-section').forEach(subSectionElm => {
                subMenuSections.push(new SubMenuSection(subSectionElm));

                subSectionElm.addEventListener('onOpened', function (e) {
                    currentOpenSubMenu = e.detail;
                });
                subSectionElm.addEventListener('onClosed', function (e) {
                    currentOpenSubMenu = null;
                });
            });
            subMenuSectionsInitialized = true;
        };

        window.addEventListener('navigate', function () {
            self._close();
        });

        this._toggle = function () {
            if (self.isOpen) {
                self._close();
            } else {
                self._open();
            }
        };

        this._open = function () {
            if (!subMenuSectionsInitialized) {
                initializeSubMenuSections();
            }

            self.elm.classList.add('top-navigation__menu-item--open');
            window.addEventListener('click', handleClickOutside);
            self.isOpen = true;

            window.timeouts.push(setTimeout(function () {
                self.elm.dispatchEvent(onOpenedEvent);
            }, 300));
        };

        this._close = function () {
            // if no open submenu, just close
            if (!currentOpenSubMenu) {
                self.elm.classList.remove('top-navigation__menu-item--open');
                window.removeEventListener('click', handleClickOutside);
                self.isOpen = false;

                window.timeouts.push(setTimeout(function () {
                    self.elm.dispatchEvent(onClosedEvent);
                }, 300));
            } else {
                let onClosedEventHandler = null;
                onClosedEventHandler = function (e) {
                    self._close();
                    e.detail.elm.removeEventListener('onClosed', onClosedEventHandler);
                };

                // Assign eventlistener to submenu, to close self when submenu is closed
                currentOpenSubMenu.elm.addEventListener('onClosed', onClosedEventHandler);
                // Close currently open submenu
                currentOpenSubMenu.close();
            }
        };

        toggleOpenElem.addEventListener('click', this._toggle.bind(this));
        toggleCloseElem.addEventListener('click', this._close.bind(this));
    }

    open() {
        this._open();
    }

    close() {
        this._close();
    }
}

class SubMenuSection {
    constructor(elm) {
        this.elm = elm;
        const self = this;
        this.isOpen = false;
        const toggleOpenElem = elm.querySelector('[data-top-navigation__submenu-section-open]');
        const toggleCloseElem = elm.querySelector('[data-top-navigation__submenu-section-close]');
        const onClosedEvent = new CustomEvent('onClosed', { detail: this });
        const onOpenedEvent = new CustomEvent('onOpened', { detail: this });

        this._open = function () {
            self.elm.classList.add('top-navigation__menu-item__submenu-section--open');
            self.isOpen = true;

            window.timeouts.push(setTimeout(function () {
                self.elm.dispatchEvent(onOpenedEvent);
            }, 300));
        };

        this._close = function () {
            self.elm.classList.remove('top-navigation__menu-item__submenu-section--open');
            self.isOpen = false;

            window.timeouts.push(setTimeout(function () {
                self.elm.dispatchEvent(onClosedEvent);
            }, 300));
        };

        toggleOpenElem?.addEventListener('click', this.open.bind(this));
        toggleCloseElem?.addEventListener('click', this.close.bind(this));
    }

    open() {
        this._open();
    }

    close() {
        this._close();
    }
}
